var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffad33;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.8,79.5l2.1-.4c1.4-.3,2.3-1.7,2-3.1-.2-1-1-1.8-2-2l-2.1-.4c-5.3-1.1-9.5-5.2-10.5-10.5l-.5-2.2c-.3-1.4-1.7-2.3-3.1-2-1,.2-1.8,1-2,2l-.4,2.1c-1.1,5.3-5.2,9.5-10.5,10.5l-2.1.4c-1.4.3-2.3,1.7-2,3.1.2,1,1,1.8,2,2l2.1.4c5.3,1.1,9.5,5.2,10.5,10.5l.4,2.1c.3,1.4,1.7,2.3,3.1,2,1-.2,1.8-1,2-2l.4-2.1c1.2-5.2,5.3-9.3,10.6-10.4h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.9,41.3l7.8-1.6c1.9-.4,3-2.2,2.7-4-.3-1.3-1.3-2.4-2.7-2.7l-7.8-1.6c-7.6-1.5-13.6-7.5-15.2-15.2l-1.6-7.8c-.4-1.9-2.2-3-4-2.7-1.3.3-2.4,1.3-2.7,2.7l-1.6,7.8c-1.5,7.6-7.5,13.6-15.2,15.2l-7.8,1.6c-1.9.4-3,2.2-2.7,4,.3,1.3,1.3,2.4,2.7,2.7l7.8,1.6c7.6,1.5,13.6,7.5,15.2,15.2l1.6,7.8c.4,1.9,2.2,3,4,2.7,1.3-.3,2.4-1.3,2.7-2.7l1.6-7.8c1.6-7.7,7.6-13.6,15.2-15.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.98721d37431d5300d6c42a92e037c6c7.svg";
export { ForwardRef as ReactComponent };